import Wrapper from 'components/reusables/wrapper'
import CoursesIndex from './components/courses/main/Index'

const CoursesAdministration: React.FC = () => {
  return (
    <Wrapper shadow={true}>
      <CoursesIndex />
    </Wrapper>
  )
}

export default CoursesAdministration
